const PALETTE = {
    white: '#fff',
    black: '#1A1A1A',
    trueBlack: '#000',
    transparent: 'transparent',
    alabaster: '#fafafa',
    gallery: '#eaeaea',
    wildSand: '#f5f5f5',
    wildSandLigth: '#f6f6f6',
    wildSandLigthAlt: '#ececec',
    alto: '#d8d8d8',
    silver: '#ccc',
    silverAlt: '#c7c7c7',
    dustyGrayLigth: '#a9a9a9',
    dustyGray: '#979797',
    dustyGray2: '#929090',
    doveGray: '#727272',
    //doveGray2: '#766a62',
    gray: '#666',
    tundora: '#404040',
    mineShaft: '#333',
    boulder: '#707070',
    mine: '#262626',
    lightOrient: '#008fbe',
    // lightOrient: '#169BA2',
    orient: '#006580',
    sherpaBlue: '#00485c',
    surfieGreen: '#10667d',
    mosque: '#025d75',
    mosqueLight: '#006983',
    dodgerBlue: '#4d90fe',
    rubi: '#af1e34',
    cardinal: '#cd233c',
    mandy: '#ea5456',
    orange: '#e66b00',
    orangeAlt: '#d96602;',
    lima: '#7ed321',
    daisyBush: '#62269c',
};

// Semantic colors
export default {
    text: PALETTE.black,
    textAlt: PALETTE.white,
    paragraph: PALETTE.mineShaft,
    heading: PALETTE.mineShaft,
    headingUnderline: PALETTE.daisyBush,
    headingUnderlineAlt: PALETTE.orient,
    background: PALETTE.white,
    backgroundAlt: PALETTE.black,
    borderSeparator: PALETTE.cardinal,
    borderBranded: PALETTE.daisyBush,
    disabled: PALETTE.silver,
    error: PALETTE.mandy,
    success: PALETTE.lima,
    btnPrimary: PALETTE.orient,
    btnPrimaryHover: PALETTE.sherpaBlue,
    btnSecondary: PALETTE.white,
    btnSecondaryHover: PALETTE.gallery,
    btnSecondaryActive: PALETTE.orient,
    btnSecondaryActiveBg: PALETTE.wildSandLigth,
    linkText: PALETTE.mineShaft,
    linkTextHover: PALETTE.daisyBush,
    defaultLinkText: PALETTE.orient,
    //transparentLightBg: rgba(PALETTE.wildSand, 0.7),
    inputPlaceholder: PALETTE.silver,
    inputBg: PALETTE.alabaster,
    input: PALETTE.boulder,
    dropdownBorder: PALETTE.orient,
    dropdownText: PALETTE.tundora,
    dropdownHover: PALETTE.gallery,
    footerBg: PALETTE.mineShaft,
    formBg: PALETTE.wildSand,
    labelBg: PALETTE.mineShaft,
    tableRow: PALETTE.wildSand,
    tableText: PALETTE.mineShaft,
    outline: PALETTE.dodgerBlue,
    // overlay: rgba('#000', 0.5),

    // Color palette should only be used when there's no appropriate "semantic" color
    palette: PALETTE,
};
